import ReactOnRails from 'react-on-rails';
import Schedule from '../src/Schedule/components/Schedule';

ReactOnRails.register({
  Schedule,
});
